import React, { useState, useEffect } from "react";
import axios from "axios";

const BASEURL = import.meta.env.VITE_REACT_APP_BACKEND_BASEURL;

const Teams = () => {
  const [teams, setTeams] = useState([]);
  const [athletes, setAthletes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editTeam, setEditTeam] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    coach1: "",
    coach2: "",
    season: "",
    athletes: [],
  });

  const [newAthlete, setNewAthlete] = useState({
    name: "",
    surname: "",
    function: "",
    number: "",
  });

  const fetchTeams = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASEURL}/teams`);
      setTeams(res.data);
    } catch (err) {
      console.error(err);
      alert("Erro ao buscar times");
    }
    setLoading(false);
  };

  const fetchAthletes = async () => {
    try {
      const res = await axios.get(`${BASEURL}/athletes`);
      setAthletes(res.data);
    } catch (err) {
      console.error(err);
      alert("Erro ao buscar atletas");
    }
  };

  useEffect(() => {
    fetchTeams();
    fetchAthletes();
  }, []);

  const openModal = (team = null) => {
    if (team) {
      setEditTeam(team);
      setFormData({
        name: team.name,
        coach1: team.coach1 || "",
        coach2: team.coach2 || "",
        season: team.season || "",
        athletes: team.athletes.map((a) => ({
          athlete: a.athlete._id,
          number: a.number,
          function: a.function,
        })),
      });
    } else {
      setEditTeam(null);
      setFormData({
        name: "",
        coach1: "",
        coach2: "",
        season: "",
        athletes: [],
      });
    }
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((f) => ({ ...f, [name]: value }));
  };

  const addAthleteToTeam = () => {
    setFormData((f) => ({
      ...f,
      athletes: [...f.athletes, { athlete: "", number: "", function: "" }],
    }));
  };

  const removeAthleteFromTeam = (index) => {
    setFormData((f) => ({
      ...f,
      athletes: f.athletes.filter((_, i) => i !== index),
    }));
  };

  const handleAthleteChange = (index, field, value) => {
    const updated = [...formData.athletes];
    updated[index][field] = value;
    setFormData((f) => ({ ...f, athletes: updated }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editTeam) {
        await axios.put(`${BASEURL}/teams/${editTeam._id}`, formData);
        // alert("Time atualizado");
      } else {
        await axios.post(`${BASEURL}/teams`, formData);
        // alert("Time criado");
      }
      closeModal();
      fetchTeams();
    } catch (err) {
      console.error(err);
      alert("Erro ao salvar time");
    }
  };

  const handleRemove = async (id) => {
    if (!window.confirm("Confirma remoção deste time?")) return;
    try {
      await axios.delete(`${BASEURL}/teams/${id}`);
      fetchTeams();
    } catch (err) {
      console.error(err);
      alert("Erro ao remover time");
    }
  };

  // Cadastro inline de atleta
  const handleNewAthleteChange = (e) => {
    const { name, value } = e.target;
    setNewAthlete((na) => ({ ...na, [name]: value }));
  };

  const handleNewAthleteSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${BASEURL}/athletes`, newAthlete);
      //   alert("Atleta criado");
      setNewAthlete({ name: "", surname: "", function: "", number: "" });
      fetchAthletes();
    } catch (err) {
      console.error(err);
      alert("Erro ao criar atleta");
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Times</h1>
      <button
        onClick={() => openModal()}
        className="mb-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Novo Time
      </button>

      {loading ? (
        <p>Carregando times...</p>
      ) : (
        <table className="w-full border-collapse border border-gray-300 text-sm">
          <thead>
            <tr className="bg-gray-200">
              <th className="border p-2 text-left">Nome</th>
              <th className="border p-2 text-left">Técnico 1</th>
              <th className="border p-2 text-left">Técnico 2</th>
              <th className="border p-2 text-left">Temporada</th>
              <th className="border p-2 text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            {teams.map((team) => (
              <tr key={team._id} className="hover:bg-gray-100">
                <td className="border p-2">{team.name}</td>
                <td className="border p-2">{team.coach1}</td>
                <td className="border p-2">{team.coach2}</td>
                <td className="border p-2">{team.season}</td>
                <td className="border p-2 text-center space-x-2">
                  <button
                    onClick={() => openModal(team)}
                    className="px-2 py-1 bg-yellow-400 rounded hover:bg-yellow-500"
                  >
                    Editar
                  </button>
                  <button
                    onClick={() => handleRemove(team._id)}
                    className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                  >
                    Remover
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {modalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded p-6 w-full max-w-lg overflow-y-auto max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-bold mb-4">
              {editTeam ? "Editar Time" : "Novo Time"}
            </h2>
            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                name="name"
                placeholder="Nome"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full border p-2 rounded"
              />
              <input
                name="coach1"
                placeholder="Técnico 1"
                value={formData.coach1}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
              <input
                name="coach2"
                placeholder="Técnico 2"
                value={formData.coach2}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />
              <input
                name="season"
                placeholder="Temporada"
                value={formData.season}
                onChange={handleChange}
                className="w-full border p-2 rounded"
              />

              <div>
                <h3 className="font-semibold mb-2">Atletas do Time</h3>
                {formData.athletes.map((item, index) => (
                  <div key={index} className="mb-2 flex space-x-2 items-center">
                    <select
                      value={item.athlete}
                      onChange={(e) =>
                        handleAthleteChange(index, "athlete", e.target.value)
                      }
                      className="border p-1 rounded w-1/3"
                    >
                      <option value="">Selecione atleta</option>
                      {athletes.map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.name} {a.surname}
                        </option>
                      ))}
                    </select>
                    <input
                      type="number"
                      placeholder="Número"
                      value={item.number}
                      onChange={(e) =>
                        handleAthleteChange(index, "number", e.target.value)
                      }
                      className="border p-1 rounded w-1/4"
                    />
                    <input
                      type="text"
                      placeholder="Função"
                      value={item.function}
                      onChange={(e) =>
                        handleAthleteChange(index, "function", e.target.value)
                      }
                      className="border p-1 rounded w-1/4"
                    />
                    <button
                      type="button"
                      onClick={() => removeAthleteFromTeam(index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      Remover
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={addAthleteToTeam}
                  className="mt-2 px-2 py-1 bg-green-500 text-white rounded hover:bg-green-600"
                >
                  Adicionar Usuário
                </button>
              </div>

              <div className="mt-4 p-3 border rounded bg-gray-50">
                <h3 className="font-semibold mb-2">Cadastrar Novo Atleta</h3>
                <input
                  name="name"
                  placeholder="Nome"
                  value={newAthlete.name}
                  onChange={handleNewAthleteChange}
                  className="w-full border p-1 rounded mb-1"
                />
                <input
                  name="surname"
                  placeholder="Sobrenome"
                  value={newAthlete.surname}
                  onChange={handleNewAthleteChange}
                  className="w-full border p-1 rounded mb-1"
                />
                <input
                  name="function"
                  placeholder="Função"
                  value={newAthlete.function}
                  onChange={handleNewAthleteChange}
                  className="w-full border p-1 rounded mb-1"
                />
                <input
                  name="number"
                  type="number"
                  placeholder="Número"
                  value={newAthlete.number}
                  onChange={handleNewAthleteChange}
                  className="w-full border p-1 rounded mb-2"
                />
                <button
                  type="button"
                  onClick={handleNewAthleteSubmit}
                  className="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  Cadastrar Usuário
                </button>
              </div>

              <div className="flex justify-end space-x-2 mt-4">
                <button
                  type="button"
                  onClick={closeModal}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Salvar Time
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Teams;
